var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.374 12.8264C10.5289 12.8975 10.7034 12.9138 10.8688 12.8725C11.0341 12.8312 11.1805 12.7348 11.2838 12.5991L11.55 12.2504C11.6897 12.0641 11.8709 11.9129 12.0792 11.8087C12.2875 11.7046 12.5171 11.6504 12.75 11.6504H15C15.3978 11.6504 15.7794 11.8084 16.0607 12.0897C16.342 12.371 16.5 12.7526 16.5 13.1504V15.4004C16.5 15.7982 16.342 16.1797 16.0607 16.4611C15.7794 16.7424 15.3978 16.9004 15 16.9004C11.4196 16.9004 7.9858 15.4781 5.45406 12.9463C2.92232 10.4146 1.5 6.98081 1.5 3.40039C1.5 3.00257 1.65804 2.62103 1.93934 2.33973C2.22064 2.05843 2.60218 1.90039 3 1.90039H5.25C5.64782 1.90039 6.02936 2.05843 6.31066 2.33973C6.59196 2.62103 6.75 3.00257 6.75 3.40039V5.65039C6.75 5.88326 6.69578 6.11293 6.59164 6.32121C6.4875 6.52949 6.33629 6.71067 6.15 6.85039L5.799 7.11364C5.66131 7.21877 5.56426 7.36833 5.52434 7.5369C5.48442 7.70548 5.50409 7.88267 5.58 8.03839C6.60501 10.1203 8.29082 11.804 10.374 12.8264Z",
    stroke: "#99A1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.d0eee3d27b810aa7a7352495abbec0fa.svg";
export { ForwardRef as ReactComponent };